import { API_BASE_URL, authFetch } from "./config";

export const fetchAllUsers = () => authFetch(`${API_BASE_URL}/users/`);

export const createUser = (data) => 
    authFetch(`${API_BASE_URL}/users/`, {
        method: 'POST',
        body: JSON.stringify(data)
    });

export const updateUser = (telegramId, data) =>
    authFetch(`${API_BASE_URL}/users/${telegramId}/`, {
        method: 'PUT',
        body: JSON.stringify(data)
    });

export const deleteUser = (telegramId) => 
    authFetch(`${API_BASE_URL}/users/${telegramId}/`, {method: 'DELETE'});